import { Injectable } from '@angular/core';
import { PageableDTO } from 'tekkeys-common';
import { BehaviorSubject } from 'rxjs';
import {ProductCardDTO} from '../../../../../projects/tekkeys-common/src/lib/DTO/product-card.dto';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  public searchResultsSubject = new BehaviorSubject<PageableDTO<ProductCardDTO>>(
    null
  );
  public searchResults$ = this.searchResultsSubject.asObservable();

  initialMaxPrice = undefined
  minPrice = 0
  maxPrice = undefined
  selectedCharacteristics: any[];
  rootCategoryId: any = '0';
  private parentCategoryIdSubject = new BehaviorSubject<number>(null);
  public parentCategoryId$ = this.parentCategoryIdSubject.asObservable();

  constructor() {
    const savedCharacteristics = localStorage.getItem('selectedCharacteristics');
    this.selectedCharacteristics = savedCharacteristics ? JSON.parse(savedCharacteristics) : [];
  }
  getParentCategoryId(): number {
    return this.parentCategoryIdSubject.value;
  }

  setParentCategoryId(categoryId: number): void {
    localStorage.setItem('parentCategoryId', categoryId.toString());
    this.parentCategoryIdSubject.next(categoryId);
  }

  setRootCategoryId(categoryId: number) {
    this.rootCategoryId = categoryId;
    localStorage.setItem('rootCategoryId', categoryId.toString());
  }

  getRootCategoryId(): any {
    const storedId = localStorage.getItem('rootCategoryId');
    return storedId ?? '0';
  }

  setSelectedCharacteristics(characteristics: any[]) {
    this.selectedCharacteristics = characteristics;
    localStorage.setItem('selectedCharacteristics', JSON.stringify(characteristics));
  }
  removeSelectedCharacteristics() {
    this.selectedCharacteristics = [];
    localStorage.removeItem('selectedCharacteristics');
  }
  getSelectedCharacteristics() {
    return localStorage.getItem('selectedCharacteristics')
      ? JSON.parse(localStorage.getItem('selectedCharacteristics'))
      : [];
  }
  // This file contains the handling of the filter section in catalog
  // 


}
